import React, { useEffect, useState } from 'react';
import { ConfigKeysEnum, useConfigKey } from '../../services/configKeys';
import { dangerNotification } from '../../services/notification';

const PowerBIPage = () => {
  const {
    data: configData,
    isSuccess,
    isError
  } = useConfigKey(ConfigKeysEnum.LINK_POWER_BI);
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (isSuccess && configData) {
      setUrl(configData.value);
    } else if (isError) {
      console.log('Erro ao carregar configuração:', isError);
      dangerNotification('Atenção!', 'Erro ao carregar link do Power BI.');
    }
  }, [isSuccess, configData, isError]);

  return (
    <div>
      {url && (
        <iframe
          title="Report Section"
          width="100%"
          height="800px"
          src={url}
          frameBorder={0}
          allowFullScreen={true}
        ></iframe>
      )}
    </div>
  );
};
export default PowerBIPage;
